import { render, staticRenderFns } from "./ResearchUmapPlotGL.vue?vue&type=template&id=316975c1&scoped=true&"
import script from "./ResearchUmapPlotGL.vue?vue&type=script&lang=js&"
export * from "./ResearchUmapPlotGL.vue?vue&type=script&lang=js&"
import style0 from "./ResearchUmapPlotGL.vue?vue&type=style&index=0&id=316975c1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "316975c1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/Portal (Dev)/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('316975c1')) {
      api.createRecord('316975c1', component.options)
    } else {
      api.reload('316975c1', component.options)
    }
    module.hot.accept("./ResearchUmapPlotGL.vue?vue&type=template&id=316975c1&scoped=true&", function () {
      api.rerender('316975c1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/singleCellBrowser/ResearchUmapPlotGL.vue"
export default component.exports